module.exports = __webpack_public_path__ + "static/img/solution_img_1.2e85f2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-n/solution_img_1.png
// module id = D5sk
// module chunks = 22